<template>
  <li class="slm-history-map__destination">
    <a
      class="slm-history-map__destination--link"
      :href="history.url"
    >
      <div class="slm-history-map__destination--info">
        <h3 class="slm-history-map__destination--title">
          {{ history.title }}
        </h3>
        <p class="slm-history-map__destination--description">
          {{ history.description }}
        </p>
      </div>
      <div
        class="slm-history-map__destination--image-wrapper"
        v-html="history.image ? history.image : fallbackImage"
      ></div>
    </a>
  </li>
</template>

<script>
export default {
  name: "history-component",
  props: ["history"],
  computed: {
    fallbackImage() {
      return this.$store.state.fallbackImage;
    },
  },
};
</script>